import { render } from "./Restart.vue?vue&type=template&id=5752928c"
import script from "./Restart.vue?vue&type=script&lang=js"
export * from "./Restart.vue?vue&type=script&lang=js"
script.render = render

export default script